import { render, staticRenderFns } from "./FlatFile.vue?vue&type=template&id=738189dc&scoped=true"
import script from "./FlatFile.vue?vue&type=script&lang=js"
export * from "./FlatFile.vue?vue&type=script&lang=js"
import style0 from "./FlatFile.vue?vue&type=style&index=0&id=738189dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738189dc",
  null
  
)

export default component.exports